import apiClient from "./axios"

export const getAccountVendorBills = async (params = {}) => {
  const { data } = await apiClient.get("/account-vendor-bills", { params })
  return data
}

export const getAccountVendorBill = async id => {
  const { data } = await apiClient.get(`/account-vendor-bills/${id}`)
  return data
}

export const createAccountVendorBill = async payload => {
  const { data } = await apiClient.post("/account-vendor-bills", payload)
  return data
}

export const updateAccountVendorBill = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-vendor-bills/${id}`, payload)
  return data
}

export const deleteAccountVendorBill = async id => {
  const { data } = await apiClient.delete(`/account-vendor-bills/${id}`)
  return data
}
